/**
 * Syariah detection utility.
 * A policy is considered Syariah if its policy number starts with '5' or '6'.
 */
export function isSyariah(policyNumber: string): boolean {
  if (!policyNumber) return false;
  return policyNumber.startsWith('5') || policyNumber.startsWith('6');
}

/** Company name based on Syariah status */
export function getCompanyName(syariah: boolean): string {
  return syariah
    ? 'PT Sun Life Financial Syariah Indonesia'
    : 'PT Sun Life Financial Indonesia';
}

/** Care email based on Syariah status */
export function getCareEmail(syariah: boolean): string {
  return syariah
    ? 'sli_care.syariah@sunlife.com'
    : 'sli_care@sunlife.com';
}

/**
 * Replace Syariah-specific wording in a text string.
 * Replaces: Premi→Kontribusi, Pemilik Polis→Pemegang Polis,
 * Tertanggung→Peserta, Biaya→Ujrah, Ahli Waris→Penerima Manfaat,
 * PT Sun Life Financial Indonesia→PT Sun Life Financial Syariah Indonesia,
 * sli_care@sunlife.com→sli_care.syariah@sunlife.com
 */
export function applySyariahWording(text: string, syariah: boolean): string {
  if (!syariah) return text;
  return text
    .replace(/PT Sun Life Financial Indonesia/g, 'PT Sun Life Financial Syariah Indonesia')
    .replace(/sli_care@sunlife\.com/g, 'sli_care.syariah@sunlife.com')
    .replace(/Pemilik Polis/g, 'Pemegang Polis')
    .replace(/Tertanggung/g, 'Peserta')
    .replace(/Ahli Waris/g, 'Penerima Manfaat')
    .replace(/Biaya/g, 'Ujrah')
    .replace(/Premi/g, 'Kontribusi')
    .replace(/premi/g, 'kontribusi');
}
